<template>
  <div class="app-header" style="z-index:1009">
    <VersionAlert />
    <div class="d-flex" :class="{ 'invisible': initPage }">
      <button
        class="navbar-toggler hamburger hamburger--elastic toggle-sidebar"
        v-bind:class="{ 'is-active': sidebarCollapsed }"
        type="button"
        v-on:click="toggleSidebar"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
      <button
        class="navbar-toggler hamburger hamburger--elastic toggle-sidebar-mobile"
        v-bind:class="{ 'is-active': sidebarCollapsedMobile }"
        type="button"
        v-on:click="toggleSidebarMobile"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>

    <Paket/>

    <div class="d-flex align-items-center">
      <Dots v-if="isQrisActive && hasFeatures()" />
      <UserBox />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Header',
  components: {
    Dots: () => import('./Header/Dots'),
    Paket: () => import('./Header/Paket'),
    UserBox: () => import('./Header/UserBox'),
    VersionAlert: () => import('./Header/VersionAlert'),
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      initPage: 'sidebar/initPage',
      getRolesName: 'getRolesName',
    }),
    sidebarCollapsed: {
      get() {
        return this.$store.state.sidebar.sidebarCollapsed;
      },
      set(value) {
        this.$store.commit('sidebar/SET_SIDEBAR_COLLAPSED', value);
      },
    },
    sidebarCollapsedMobile: {
      get() {
        return this.$store.state.sidebar.sidebarCollapsedMobile;
      },
      set(value) {
        this.$store.commit('sidebar/SET_SIDEBAR_COLLAPSED_MOBILE', value);
      },
    },
    isQrisActive() {
      return this.$store.state.isQrisActive;
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    toggleSidebarMobile() {
      this.sidebarCollapsedMobile = !this.sidebarCollapsedMobile;
    },
    hasFeatures() {
      const features = ['pic_pusat', 'pic_cabang', 'frontdesk', 'kasir', 'apoteker'];
      const isOwner = features.filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
  }
};
</script>
